import { Chip, ChipProps, SxProps } from "@mui/material";

export interface ShortcutIndicatorProps {
  keys: string[];
  minWidth?: number;
  sx?: SxProps;
  color?: ChipProps["color"];
  fitContent?: boolean;
  separator?: string;
}

export const ShortcutIndicator = ({
  keys,
  minWidth,
  sx,
  fitContent = false,
  color = "secondary",
  separator = " ",
}: ShortcutIndicatorProps) => {
  const isNotSingleCharacter = keys.length >= 2;
  const fixedWidth = isNotSingleCharacter || fitContent ? "fit-content" : 28;

  const chipWidth = minWidth ? minWidth : fixedWidth;

  return (
    <Chip
      label={keys.join(separator)}
      variant="filled"
      color={color}
      size="small"
      sx={{
        ...sx,
        maxWidth: chipWidth,
        height: "24px",
        borderRadius: "4px",
        padding: "4px 8px",
        pointerEvents: "none",
        userSelect: "none",

        "& .MuiChip-label": {
          textOverflow: "clip",
          whiteSpace: "nowrap",
          minWidth: chipWidth,
          textAlign: "center",
          padding: 0,
        },
      }}
    />
  );
};
